import { Shield, Sparkles, Users, Heart } from "lucide-react";

const features = [
  {
    icon: Sparkles,
    title: "Sanitized Grooming Stations",
    description: "Every station is thoroughly cleaned and sanitized between appointments for maximum hygiene.",
  },
  {
    icon: Users,
    title: "Trained Staff",
    description: "Our team is professionally trained in handling pets of all sizes, temperaments, and breeds.",
  },
  {
    icon: Heart,
    title: "Pet-Friendly Environment",
    description: "Designed with your pet's comfort in mind. Calming atmosphere to reduce stress and anxiety.",
  },
  {
    icon: Shield,
    title: "Safety-First Approach",
    description: "We prioritize the safety of your pet at every step, using gentle techniques and quality products.",
  },
];

export const FacilitySection = () => {
  return (
    <section
      id="facility"
      data-testid="facility-section"
      className="py-16 md:py-24 bg-slate-50"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative animate-slide-in-left">
            <div className="rounded-3xl overflow-hidden shadow-2xl shadow-sky-200/30">
              <img
                src="https://images.unsplash.com/photo-1715626000681-a0074b4d9783?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBwZXQlMjBncm9vbWluZyUyMHNhbG9uJTIwaW50ZXJpb3IlMjBjbGVhbnxlbnwwfHx8fDE3NzI1NjAwNzF8MA&ixlib=rb-4.1.0&q=85"
                alt="Clean modern grooming salon interior"
                className="w-full h-auto object-cover aspect-[4/3]"
                data-testid="facility-image"
              />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-white rounded-2xl p-4 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                  <Shield className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <p className="font-semibold text-slate-900">100% Safe</p>
                  <p className="text-sm text-slate-500">Clean Environment</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8 animate-slide-in-right">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Our Facility & Safety Standards
              </h2>
              <div className="section-divider mb-6"></div>
              <p className="text-lg text-slate-600">
                We maintain the highest standards of cleanliness and safety to ensure your pet has a comfortable and stress-free grooming experience.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={index}
                    data-testid={`facility-feature-${index}`}
                    className="p-5 bg-white rounded-2xl border border-slate-100 shadow-sm hover-lift"
                  >
                    <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-sky-600" />
                    </div>
                    <h3 className="font-semibold text-slate-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-slate-500">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacilitySection;
